export default __webpack_public_path__ + "static/media/HomeBanner3.b5e2a67f.jpg";